export * from './zahlungseingang-gespeichert.interface';
